import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["value", "type"]


import commonProps from "../props/commonProps";

export interface TextInputFormatter {
  format: (value: string) => string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCustom',
  props: {
  ...commonProps,
  textInputFormatters: {
    type: Array as () => TextInputFormatter[],
    default: () => [],
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const applyFormatters = (value: string) => {
  return props.textInputFormatters.reduce((formattedValue, formatter) => {
    return formatter.format(formattedValue);
  }, value);
};

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const formattedValue = applyFormatters(target.value);
  emit("update:modelValue", formattedValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$attrs.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass({ required: _ctx.$attrs.required })
        }, _toDisplayString(_ctx.$attrs.label), 3))
      : _createCommentVNode("", true),
    _createElementVNode("input", _mergeProps({
      class: "form-control",
      value: _ctx.modelValue
    }, _ctx.$attrs, {
      onInput: handleInput,
      type: _ctx.type
    }), null, 16, _hoisted_1)
  ]))
}
}

})